var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyListIcon = function SvgEmptyListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 96,
    fill: "none",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC76C",
    d: "M16.204 25.926c5.37 0 9.722-4.353 9.722-9.722 0-5.37-4.353-9.723-9.722-9.723-5.37 0-9.723 4.353-9.723 9.723s4.353 9.722 9.723 9.722M3.704 7.407a3.704 3.704 0 1 0 0-7.407 3.704 3.704 0 0 0 0 7.407"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB6552",
    d: "M111.195 84.312a4.673 4.673 0 0 0 6.456 1.484 4.71 4.71 0 0 0 1.479-6.482 4.673 4.673 0 0 0-6.456-1.484 4.713 4.713 0 0 0-1.479 6.482"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#emptyListIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ED8F0",
    d: "M96.144 7H35.717a3.546 3.546 0 0 0-3.551 3.542V19.8a3.546 3.546 0 0 0 3.55 3.542h60.428a3.546 3.546 0 0 0 3.55-3.542v-9.26A3.546 3.546 0 0 0 96.144 7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEE1BF",
    d: "M94.825 29.348H37.337a5.165 5.165 0 0 0-5.171 5.158v45.34a5.165 5.165 0 0 0 5.171 5.158h57.488c2.856 0 5.17-2.31 5.17-5.158v-45.34a5.164 5.164 0 0 0-5.17-5.158"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M90.865 9.893h-61.1c-3.184 0-5.765 2.575-5.765 5.751v61.077c0 3.177 2.581 5.752 5.766 5.752h61.099c3.184 0 5.765-2.575 5.765-5.752V15.644c0-3.176-2.58-5.75-5.765-5.75m-61.1 2.58h61.1a3.18 3.18 0 0 1 3.18 3.171v9.242h-67.46v-9.242a3.18 3.18 0 0 1 3.18-3.172m61.1 67.42h-61.1a3.18 3.18 0 0 1-3.18-3.172V27.895h67.46v48.826a3.18 3.18 0 0 1-3.18 3.173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M44.779 20.368h41.41c.832 0 1.509-.675 1.509-1.504 0-.83-.677-1.505-1.509-1.505H44.78c-.832 0-1.509.675-1.509 1.505s.677 1.504 1.509 1.504M38.185 20.368h1.241c.832 0 1.509-.675 1.509-1.504 0-.83-.677-1.505-1.509-1.505h-1.24c-.832 0-1.509.675-1.509 1.505s.677 1.504 1.508 1.504M32.265 20.368h1.241c.832 0 1.508-.675 1.508-1.504 0-.83-.676-1.505-1.508-1.505h-1.241c-.832 0-1.508.675-1.508 1.505s.676 1.504 1.508 1.504"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB6552",
    d: "M89.978 87.96c2.749 4.4 8.53 5.729 12.912 2.969s5.707-8.564 2.957-12.963c-2.749-4.4-8.53-5.729-12.912-2.969s-5.706 8.564-2.957 12.963"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "emptyListIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 7h76v78H24z"
  })))));
};
export default SvgEmptyListIcon;